module.exports = __webpack_public_path__ + "static/bg_HeroCs_mobile-6aecd821b5c3ce524046d0a4370f97e7.jpg";